<script setup lang="ts">
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group"
import { Label } from "@/components/ui/label"
import Callout from './Callout.vue'

const props = defineProps<{
  id: string
  target: HTMLElement | null
  show: boolean
  resourceFilter: any
  users: any[]
}>()

const emit = defineEmits(['close', 'updateFilter'])

function toggleSelection(userId: number) {
  let updated = [...props.resourceFilter.individual]
  if (updated.includes(userId)) {
    updated = updated.filter(i => i !== userId)
  } else {
    updated.push(userId)
  }
  emit('updateFilter', { ...props.resourceFilter, individual: updated })
}
</script>

<template>
  <Callout :id="id" :target="target" :show="show" @close="emit('close')">
    <div class="flex flex-col space-y-2" @click.stop>
      <div class="w-fit rounded-md gap-4 bg-popover p-2">
        <RadioGroup
          :model-value="resourceFilter.selection"
          @update:model-value="(val) => emit('updateFilter', { ...resourceFilter, selection: val })"
          class="flex flex-col space-y-2"
        >
          <div class="flex items-center space-x-2 cursor-pointer rounded-md px-2 py-1 hover:bg-muted" @click="emit('updateFilter', { ...resourceFilter, selection: 0 })">
            <RadioGroupItem :value="0" />
            <span>gebucht</span>
          </div>
          <div class="flex items-center space-x-2 cursor-pointer rounded-md px-2 py-1 hover:bg-muted" @click="emit('updateFilter', { ...resourceFilter, selection: 1 })">
            <RadioGroupItem :value="1" />
            <span>auswählen</span>
          </div>
          <div class="flex items-center space-x-2 cursor-pointer rounded-md px-2 py-1 hover:bg-muted" @click="emit('updateFilter', { ...resourceFilter, selection: 2 })">
            <RadioGroupItem :value="2" />
            <span>Alle</span>
          </div>
        </RadioGroup>
      </div>
      
      <div v-show="resourceFilter.selection === 1" class="max-h-64 overflow-y-auto pr-2 mt-2 border-t pt-2">
        <div v-for="u in users" :key="u.id" class="flex items-center space-x-2 py-1">
          <input type="checkbox" :checked="resourceFilter.individual.includes(u.id)" @change="toggleSelection(u.id)" />
          <Label>{{ u.firstname }} {{ u.lastname }} ({{ u.short }})</Label>
        </div>
      </div>
    </div>
  </Callout>
</template>